export default "__VITE_ASSET__t54naTNw__"